import { render, staticRenderFns } from "./ViewChangeRequestPolicyDetails.vue?vue&type=template&id=614a8462"
import script from "./ViewChangeRequestPolicyDetails.vue?vue&type=script&lang=ts"
export * from "./ViewChangeRequestPolicyDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports